import React from 'react';
import { BasicResponsiveImage, Box, FlexBox } from '@vp/swan';
import styled from 'styled-components';

interface AvatarProps {
    $size: number;
    $overlap: number;
    $isFirst: boolean;
}

const Avatar = styled(Box)<AvatarProps>`
    position: relative;
    min-width: ${({ $size }) => $size}px;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    border-radius: 50%;
    overflow: hidden;
    margin-left: ${({ $isFirst, $overlap }) => ($isFirst ? 0 : -$overlap)}px;
`;

export interface LayeredAvatarsProps {
    avatarUrls: ReadonlyArray<string | null | undefined>;
    /** Diameter of each avatar in px. Defaults to 32. */
    size?: number;
    /** Maximum number of avatars to render. Defaults to 3. */
    max?: number;
    /** Alt text used on each avatar image. */
    alt?: string;
}

export function LayeredAvatars({ avatarUrls, size = 32, max = 3, alt = '' }: LayeredAvatarsProps) {
    const visible = avatarUrls
        .filter((url): url is string => Boolean(url))
        .slice(0, max)
        .reverse();
    if (visible.length === 0) {
        return null;
    }
    const overlap = Math.round(size * 0.35);

    return (
        <FlexBox alignItems="center">
            {visible.map((url, index) => (
                <Avatar
                    key={`${url}-${index}`}
                    $size={size}
                    $overlap={overlap}
                    $isFirst={index === 0}
                    style={{ zIndex: index }}
                >
                    <BasicResponsiveImage src={url} alt={alt} aspectRatio={1} />
                </Avatar>
            ))}
        </FlexBox>
    );
}
